import type { StateCreator } from "zustand";
import type { IState } from "~/lib/stateManagement/persistedState/persistedStore";

export interface IShowroomState {
	showroomToken: string;
	setShowroomToken: (tokenValue: string) => void;
	clearShowroomToken: () => void;
}

export const createShowroomSlice: StateCreator<IState, [], [], IShowroomState> = (set, _get) => ({
	showroomToken: "",
	setShowroomToken: (tokenValue: string) => set(() => ({ showroomToken: tokenValue })),
	clearShowroomToken: () => set(() => ({ showroomToken: "" })),
});
